import axios from 'axios';
import '../config.js';

const DEFAULT_CLIENT_COOLDOWN_ENABLED = true;
const DEFAULT_CLIENT_COOLDOWN_SECONDS = 90;

/**
 * @returns {Promise<import('./types/notifications').NotificationSettingsResponse>}
 */
export const getSettings = async (id, appProviderId) => {
  const token = localStorage.getItem('token');
  let url = global.config.url + `/notifications/settings/${id}`;
  if (appProviderId !== null && appProviderId !== undefined && appProviderId !== '') {
    url = url + `?appProviderId=${appProviderId}`;
  }
  const response = await axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  const data = response.data;

  // Backward compatibility: older servers may omit these preference fields.
  if (data && data.preferences) {
    const pref = data.preferences;
    const nextPref = {
      ...pref,
      clientCooldownEnabled:
        typeof pref.clientCooldownEnabled === 'boolean'
          ? pref.clientCooldownEnabled
          : DEFAULT_CLIENT_COOLDOWN_ENABLED,
      clientCooldownSeconds:
        Number.isFinite(Number(pref.clientCooldownSeconds))
          ? Number(pref.clientCooldownSeconds)
          : DEFAULT_CLIENT_COOLDOWN_SECONDS,
    };
    return { ...data, preferences: nextPref };
  }

  return data;
};

/**
 * @param {import('./types/notifications').NotificationSettingsRequest} payload
 * @returns {Promise<void>}
 */
export const updateSettings = async (id, payload, appProviderId) => {
  const token = localStorage.getItem('token');
  let url = global.config.url + `/notifications/settings/${id}`;
  if (appProviderId !== null && appProviderId !== undefined && appProviderId !== '') {
    url = url + `?appProviderId=${appProviderId}`;
  }

  const pref = payload && payload.preferences ? payload.preferences : {};

  const safePayload = {
    ...payload,
    preferences: {
      ...pref,
      clientCooldownEnabled:
        typeof pref.clientCooldownEnabled === 'boolean'
          ? pref.clientCooldownEnabled
          : DEFAULT_CLIENT_COOLDOWN_ENABLED,
      clientCooldownSeconds: Number.isFinite(Number(pref.clientCooldownSeconds))
        ? Number(pref.clientCooldownSeconds)
        : DEFAULT_CLIENT_COOLDOWN_SECONDS,
    },
  };

  await axios.put(url, safePayload, {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: `Bearer ${token}`,
    },
  });
};

const notificationsApi = {
  getSettings,
  updateSettings,
};

export default notificationsApi;
